import { makeStyles, Text } from '@fluentui/react-components';
import { LoaderIcon } from '@utils-global';
import { useAutofocus } from '@utils';
import { useTranslation } from 'react-i18next';
import { useIsV2 } from '@data';

const useStyles = makeStyles({
  loader: {
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: '24px',
  },
  loaderWrapper: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: '16px',
  },
  v2LoaderWrapper: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: '16px',
    background: 'linear-gradient(to bottom right, #091731, #1D305A)',
    minHeight: '100vh',
    width: '100%',
  },
  title: {
    color: '#14141E',
  },
  v2Title: {
    color: '#ffffff',
    marginTop: '16px',
    marginBottom: '8px',
  },
  description: {
    color: '#706F6F',
  },
  v2Description: {
    color: '#E0E0E0',
  },
});

export const ReportLoading = () => {
  const styles = useStyles();
  const { t } = useTranslation();
  const { targetRef } = useAutofocus();
  const isV2 = useIsV2();

  if (isV2) {
    return (
      <section
        tabIndex={-1}
        ref={targetRef}
        className={styles.v2LoaderWrapper}
        aria-label="Report in progress page"
      >
        <LoaderIcon className={styles.loader} aria-hidden="true" />
        <Text weight="bold" className={styles.v2Title} size={400} role="heading">
          {t('reportPage.loading.title')}
        </Text>
        <Text weight="semibold" size={300} className={styles.v2Description}>
          {t('reportPage.loading.subtitle')}
        </Text>
      </section>
    );
  }
  return (
    <section
      tabIndex={-1}
      ref={targetRef}
      className={styles.loaderWrapper}
      aria-label="Report in progress page"
    >
      <LoaderIcon className={styles.loader} aria-hidden="true" />
      <Text weight="bold" className={styles.title} size={300} role="heading">
        {t('reportPage.loading.title')}
      </Text>
      <Text weight="semibold" size={300} className={styles.description}>
        {t('reportPage.loading.subtitle')}
      </Text>
    </section>
  );
};
